import { render, staticRenderFns } from "./Admin_Index.vue?vue&type=template&id=9cf29108&scoped=true"
import script from "./Admin_Index.vue?vue&type=script&lang=js"
export * from "./Admin_Index.vue?vue&type=script&lang=js"
import style0 from "./Admin_Index.vue?vue&type=style&index=0&id=9cf29108&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf29108",
  null
  
)

export default component.exports